import { render, staticRenderFns } from "./Rehabilitation.vue?vue&type=template&id=50ea0088&"
import script from "./Rehabilitation.vue?vue&type=script&lang=js&"
export * from "./Rehabilitation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports